import { LoadingScreen } from "@shared/components/molecules/LoadingScreen/LoadingScreen";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

/**
 * Gate de admin. Renderiza <Outlet/> si el usuario es admin o system.
 *
 * Defensa en profundidad: si el árbol de rutas se reorganiza y este
 * componente queda sin un `ProtectedRoute` padre, el `LoadingScreen`
 * evita dejar pasar usuarios no autenticados mientras `checkAuth` corre.
 */
export function AdminRoute() {
	const user = useAuthStore((s) => s.user);
	const isLoading = useAuthStore((s) => s.isLoading);
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

	if (isLoading) return <LoadingScreen />;
	if (!isAuthenticated) return <Navigate to="/login" replace />;
	if (user && user.role !== "admin" && !user.is_system) {
		return <Navigate to="/dashboard" replace />;
	}
	return <Outlet />;
}